<template>
  <div v-show="activeTab === 'services'">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-6" id="account-lock-types">
            <div class="panel">
              <div class="panel-body">
                <div class="rentals-form-inner">
                  <div class="panel-content-inner">
                    <h4 class="inner-title">{{ $t("input.device") }}</h4>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group form-material">
                          <label for="lock-accounts">
                            {{ $t("input.lock_account") }}
                          </label>
                          <select
                            name="account_lock_type"
                            id="lock-accounts"
                            class="form-control"
                            v-model="lockComputed"
                            @change="getLocksOfAccount(lockComputed)"
                          >
                            <option></option>
                            <option
                              v-for="lockType in accountLockTypes"
                              :value="lockType.type"
                            >
                              {{ lockType.type }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6" id="pricelabs-tab">
            <div class="panel">
              <div class="panel-body">
                <div class="panel-content-inner">
                  <h4 class="inner-title">
                    {{ $t("rentals.detail.service_tab.pricelabs") }}
                  </h4>
                  <span>
                    {{ $t("rentals.detail.service_tab.pricelabs_info") }}
                  </span>
                  <div class="form-group form-material m-t-10">
                    <div class="mb-30">
                      <label class="control-label" for="price-lab-email">
                        {{ $t("rentals.detail.service_tab.pricelabs_email") }}
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="price-lab-email"
                        :disabled="disableInput"
                        @input="(e) => $emit('changePriceLabEmail', e)"
                        :value="priceLabEmail"
                      />
                    </div>
                    <div
                      class="checkbox-custom checkbox-inline checkbox-primary"
                    >
                      <input
                        type="checkbox"
                        id="price-lab"
                        name="price-lab"
                        @change="(e) => $emit('enablePriceLab', e)"
                        :checked="!disableInput"
                      />
                      <label for="price-lab">
                        {{
                          $t("rentals.detail.service_tab.connect_pricelabs")
                        }}</label
                      >
                    </div>
                    <div class="mt-15 mb-30" v-if="!disableInput">
                      <img
                        src="static/assets/images/SuperHote_icons/sync.svg"
                        id="sync-btn"
                        alt="NO IMAGE"
                        class="sync-room-dates-icon"
                        @click="syncPriceLab"
                      />
                      <label for="sync-btn" class="sync-text">{{
                        $t("rentals.detail.service_tab.synchronize")
                      }}</label>
                    </div>

                    <span>
                      {{ $t("rentals.detail.service_tab.pricelabs_info_api") }}
                    </span>
                    <div class="form-group form-material m-t-10">
                      <div class="mb-30">
                        <label class="control-label" for="price-lab-api-key">
                          {{ $t("rentals.detail.service_tab.pricelabs_api_key") }}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="price-lab-api-key"
                          :disabled="disableInput"
                          @input="(e) => $emit('changePriceLabApiKey', e)"
                          :value="priceLabApiKey"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-6"
            id="super-checkin-devices-tab"
            v-show="isSuperCheckinSelected"
          >
            <div class="panel">
              <div class="panel-body">
                <div class="row">
                  <div
                    class="col-sm-12 rentals-form-inner"
                    v-if="
                      Object.keys(superCheckinAccount).length &&
                      superCheckinLocks.length === 0
                    "
                  >
                    <div class="panel-content-inner">
                      <div class="list-rental-empty list-rental-empty-step">
                        <div>
                          <img
                            src="/static/assets/images/SuperHote_icons/rent.png"
                          />
                          <span class="no-result">{{
                            $t("rentals.detail.no_locks_for_the_account")
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-12 rentals-form-inner"
                    v-show="superCheckinLocks.length > 0"
                  >
                    <div class="panel-content-inner">
                      <h4 class="inner-title">
                        {{ $t("rentals.detail.superCheckin") }}
                      </h4>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group form-material">
                            <div class="row" v-for="lock in superCheckinLocks">
                              <div class="col-3">
                                <label class="control-label">
                                  {{ $t("input.device") }}
                                </label>
                                <div class="form-group form-material m-t-10">
                                  <div
                                    class="checkbox-custom checkbox-inline checkbox-primary"
                                  >
                                    <input
                                      type="checkbox"
                                      :id="'superCheckinLock-' + lock.id"
                                      name="super_checkin"
                                      v-model="lock.connected"
                                      :checked="!!lock.connected"
                                      @change="
                                        updateAllLocks(lock, 'supercheckin')
                                      "
                                    />
                                    <label
                                      :for="'superCheckinLock-' + lock.id"
                                      >{{
                                        `${lock.lock_name} (${lock.lock_id})`
                                      }}</label
                                    >
                                  </div>
                                </div>
                              </div>
                              <div class="col-3">
                                <label
                                  class="control-label"
                                  for="lock-type-supercheckin"
                                  >{{ $t("input.type") }}</label
                                >
                                <select
                                  class="form-control"
                                  id="lock-type-supercheckin"
                                  v-model="lock.lock_type_id"
                                  required
                                >
                                  <option
                                    v-for="type in lock_types"
                                    :value="type.id"
                                  >
                                    {{ type.name }}
                                  </option>
                                </select>
                              </div>
                              <div class="col-3">
                                <div class="form-group form-material">
                                  <label
                                    for="super-arrival-time"
                                    class="control-label"
                                  >
                                    {{ $t("input.arrival_time") }}
                                  </label>
                                  <input
                                    type="time"
                                    class="form-control m-t-2"
                                    id="super-arrival-time"
                                    v-on:keydown="stopWriting($event)"
                                    step="900"
                                    v-model="lock.arrival_time"
                                  />
                                </div>
                              </div>
                              <div class="col-3">
                                <div class="form-group form-material">
                                  <label
                                    for="super-departure-time"
                                    class="control-label"
                                  >
                                    {{ $t("input.departure_time") }}
                                  </label>
                                  <input
                                    type="time"
                                    class="form-control m-t-2"
                                    id="super-departure-time"
                                    v-on:keydown="stopWriting($event)"
                                    step="900"
                                    v-model="lock.departure_time"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6" id="the-keys-lock-tab" v-show="isTheKeysSelected">
            <div class="panel">
              <div class="panel-body">
                <div class="row">
                  <div
                    class="col-sm-12 rentals-form-inner"
                    v-if="theKeys.length === 0"
                  >
                    <div class="panel-content-inner">
                      <div class="list-rental-empty list-rental-empty-step">
                        <div>
                          <img
                            src="/static/assets/images/SuperHote_icons/rent.png"
                          />
                          <span class="no-result">{{
                            $t("rentals.detail.no_locks_for_the_account")
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-12 rentals-form-inner"
                    v-show="theKeys.length > 0"
                  >
                    <div class="panel-content-inner">
                      <h4 class="inner-title">
                        {{ $t("rentals.detail.the_keys.title") }}
                      </h4>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group form-material">
                            <label class="control-label">
                              {{ $t("rentals.detail.the_keys.label") }}
                            </label>
                            <div class="row" v-for="lock in theKeys">
                              <div class="col-4 lock-name">
                                <div class="form-group form-material">
                                  <div
                                    class="checkbox-custom checkbox-inline checkbox-primary"
                                  >
                                    <input
                                      type="checkbox"
                                      name="checkbox"
                                      v-model="lock.connected"
                                      :id="'lock-' + lock.id"
                                      :checked="!!lock.connected"
                                      @change="updateAllLocks(lock, 'TheKeys')"
                                    />
                                    <label :for="'lock-' + lock.id">{{
                                      `${lock.name} (${lock.local_id})`
                                    }}</label>
                                  </div>
                                </div>
                              </div>
                              <div class="col-2">
                                <div class="form-group" v-show="lock.connected">
                                  <label
                                    class="control-label"
                                    for="lock-type"
                                    >{{ $t("input.type") }}</label
                                  >
                                  <select
                                    class="form-control"
                                    id="lock-type"
                                    v-model="lock.type"
                                    required
                                  >
                                    <option
                                      v-for="type in lock_types"
                                      :value="type"
                                    >
                                      {{ type.name }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-2">
                                <div class="form-group form-material">
                                  <label
                                    class="control-label"
                                    for="association_id"
                                    >{{
                                      $t("rentals.detail.the_keys.accessory_id")
                                    }}</label
                                  >
                                  <input
                                    type="text"
                                    class="form-control m-t-2"
                                    id="association_id"
                                    v-model="lock.accessory_code"
                                  />
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="row">
                                  <div class="col-6">
                                    <div class="form-group form-material">
                                      <label class="control-label"
                                        >{{ $t("input.arrival_time") }}
                                      </label>
                                      <vue-timepicker
                                        format="HH:mm"
                                        :minute-interval="15"
                                        :hide-clear-button="true"
                                        v-model="lock.timeIn"
                                        @change="
                                          onLockDetailsChange('arrival', lock)
                                        "
                                        class="form-control m-t-2 checkin-checkout-time"
                                      ></vue-timepicker>
                                    </div>
                                  </div>
                                  <div class="col-6">
                                    <div class="form-group form-material">
                                      <label class="control-label">{{
                                        $t("input.departure_time")
                                      }}</label>
                                      <vue-timepicker
                                        format="HH:mm"
                                        :minute-interval="15"
                                        :hide-clear-button="true"
                                        v-model="lock.timeOut"
                                        @change="
                                          onLockDetailsChange('departure', lock)
                                        "
                                        class="form-control m-t-2 checkin-checkout-time"
                                      ></vue-timepicker>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-6"
            id="igloohome-devices-tab"
            v-show="isIgloohomeSelected"
          >
            <div class="panel">
              <div class="panel-body">
                <div class="row">
                  <div
                    class="col-sm-12 rentals-form-inner"
                    v-if="igloohomeLocks.length === 0"
                  >
                    <div class="panel-content-inner">
                      <div class="list-rental-empty list-rental-empty-step">
                        <div>
                          <img
                            src="/static/assets/images/SuperHote_icons/rent.png"
                          />
                          <span class="no-result">{{
                            $t("rentals.detail.no_locks_for_the_account")
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-12 rentals-form-inner"
                    v-show="igloohomeLocks.length > 0"
                  >
                    <div class="panel-content-inner">
                      <h4 class="inner-title">
                        {{
                          $t(
                            "account.settings.user_services_section.igloohome.title"
                          )
                        }}
                      </h4>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group form-material">
                            <label>
                              {{ $t("rentals.detail.the_keys.label") }}
                            </label>
                            <div
                              class="row"
                              v-for="igloohomeLock in igloohomeLocks"
                            >
                              <div class="col-4 lock-name">
                                <div class="form-group form-material">
                                  <div
                                    class="checkbox-custom checkbox-inline checkbox-primary"
                                  >
                                    <input
                                      :id="'igloohomeLock-' + igloohomeLock.id"
                                      type="checkbox"
                                      name="igloohome"
                                      v-model="igloohomeLock.connected"
                                      :checked="!!igloohomeLock.connected"
                                      @change="
                                        updateAllLocks(
                                          igloohomeLock,
                                          'igloohome'
                                        )
                                      "
                                    />
                                    <label
                                      :for="'igloohomeLock-' + igloohomeLock.id"
                                    >
                                      {{
                                        `${igloohomeLock.lock_name} (${igloohomeLock.lock_id})`
                                      }}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div class="col-2">
                                <div
                                  class="form-group"
                                  v-show="igloohomeLock.connected"
                                >
                                  <label
                                    class="control-label"
                                    for="lock-type-igloohome"
                                    >{{ $t("input.type") }}</label
                                  >
                                  <select
                                    class="form-control"
                                    id="lock-type-igloohome"
                                    v-model="igloohomeLock.lock_type_id"
                                    required
                                  >
                                    <option
                                      v-for="type in lock_types"
                                      :value="type.id"
                                    >
                                      {{ type.name }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="row">
                                  <div class="col-sm-6">
                                    <div class="form-group form-material">
                                      <label
                                        for="igloohome-arrival-time"
                                        class="control-label"
                                      >
                                        {{ $t("input.arrival_time") }}
                                      </label>
                                      <input
                                        type="time"
                                        class="form-control m-t-2"
                                        id="igloohome-arrival-time"
                                        v-on:keydown="stopWriting($event)"
                                        step="900"
                                        v-model="igloohomeLock.arrival_time"
                                      />
                                    </div>
                                  </div>
                                  <div class="col-sm-6">
                                    <div class="form-group form-material">
                                      <label
                                        for="igloohome-departure-time"
                                        class="control-label"
                                      >
                                        {{ $t("input.departure_time") }}
                                      </label>
                                      <input
                                        type="time"
                                        class="form-control m-t-2"
                                        id="igloohome-departure-time"
                                        v-on:keydown="stopWriting($event)"
                                        step="900"
                                        v-model="igloohomeLock.departure_time"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6" id="nuki-devices-tab" v-show="isNukiLockSelected">
            <div class="panel">
              <div class="panel-body">
                <div class="row">
                  <div
                    class="col-sm-12 rentals-form-inner"
                    v-if="nukiLocks.length === 0"
                  >
                    <div class="panel-content-inner">
                      <div class="list-rental-empty list-rental-empty-step">
                        <div>
                          <img
                            src="/static/assets/images/SuperHote_icons/rent.png"
                          />
                          <span class="no-result">{{
                            $t("rentals.detail.no_locks_for_the_account")
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-sm-12 rentals-form-inner"
                    v-show="nukiLocks.length > 0"
                  >
                    <div class="panel-content-inner">
                      <h4 class="inner-title">
                        {{
                          $t(
                            "account.settings.user_services_section.nuki_lock.title"
                          )
                        }}
                      </h4>

                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group form-material">
                            <label>
                              {{ $t("rentals.detail.the_keys.label") }}
                            </label>

                            <div
                              class="row bordered"
                              v-for="nukiLock in nukiLocks"
                            >
                              <div class="col-12 lock-name">
                                <div class="form-group form-material">
                                  <div
                                    class="checkbox-custom checkbox-inline checkbox-primary"
                                  >
                                    <input
                                      :id="'nukiLock-' + nukiLock.id"
                                      type="checkbox"
                                      name="nuki"
                                      v-model="nukiLock.connected"
                                      :checked="!!nukiLock.connected"
                                      @change="updateAllLocks(nukiLock, 'nuki')"
                                    />
                                    <label :for="'nukiLock-' + nukiLock.id">
                                      {{
                                        `${nukiLock.name} (${nukiLock.smart_lock_id})`
                                      }}
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12">
                                <div class="row">
                                  <div class="col-sm-6">
                                    <div class="form-group form-material">
                                      <div
                                        class="checkbox-custom checkbox-inline checkbox-primary"
                                      >
                                        <input
                                          id="keypadEnabled"
                                          type="checkbox"
                                          name="keypadEnabled"
                                          v-model="nukiLock.keypad_enabled"
                                          :checked="!!nukiLock.keypad_enabled"
                                          @change="
                                            updateAllLocks(nukiLock, 'nuki')
                                          "
                                        />
                                        <label for="keypadEnabled">
                                          {{
                                            $t(
                                              "account.settings.user_services_section.nuki_lock.keypad_enabled"
                                            )
                                          }}
                                        </label>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-sm-6">
                                    <div class="form-group form-material">
                                      <div
                                        class="checkbox-custom checkbox-inline checkbox-primary"
                                      >
                                        <input
                                          id="inviteLinkEnabled"
                                          type="checkbox"
                                          name="inviteLinkEnabled"
                                          v-model="nukiLock.invite_link_enabled"
                                          :checked="
                                            !!nukiLock.invite_link_enabled
                                          "
                                          @change="
                                            updateAllLocks(nukiLock, 'nuki')
                                          "
                                        />
                                        <label for="inviteLinkEnabled">
                                          {{
                                            $t(
                                              "account.settings.user_services_section.nuki_lock.invite_link_enabled"
                                            )
                                          }}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12">
                                <div class="row">
                                  <div class="col-sm-6">
                                    <div class="form-group form-material">
                                      <label
                                        for="nuki-arrival-time"
                                        class="control-label"
                                      >
                                        {{ $t("input.arrival_time") }}
                                      </label>
                                      <input
                                        type="time"
                                        class="form-control m-t-2"
                                        id="nuki-arrival-time"
                                        v-on:keydown="stopWriting($event)"
                                        step="900"
                                        v-model="nukiLock.arrival_time"
                                      />
                                    </div>
                                  </div>
                                  <div class="col-sm-6">
                                    <div class="form-group form-material">
                                      <label
                                        for="nuki-departure-time"
                                        class="control-label"
                                      >
                                        {{ $t("input.departure_time") }}
                                      </label>
                                      <input
                                        type="time"
                                        class="form-control m-t-2"
                                        id="nuki-departure-time"
                                        v-on:keydown="stopWriting($event)"
                                        step="900"
                                        v-model="nukiLock.departure_time"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-6"
            id="netatmo-devices-tab"
            v-show="netatmoDevices.length > 0"
          >
            <div class="panel">
              <div class="panel-body">
                <div class="row">
                  <div class="col-sm-12 rentals-form-inner">
                    <div class="panel-content-inner">
                      <h4 class="inner-title">
                        {{ $t("rentals.detail.netatmo") }}
                      </h4>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group form-material">
                            <label
                              class="control-label"
                              for="rentals-netatmo-device"
                            >
                              {{ $t("input.device") }}
                            </label>
                            <select
                              class="form-control"
                              id="rentals-netatmo-device"
                              name="netatmo_device_id"
                              v-model="rental.netatmo_device_id"
                              @change="selectNetatmoDeviceId"
                            >
                              <option
                                v-for="device in netatmoDevices"
                                :value="device.id"
                              >
                                {{ device.station_name }} ({{
                                  device.device_id_from_netatmo
                                }})
                              </option>
                              <option :value="null"></option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimePicker from "vue2-timepicker";
import rentalService from "../../../services/rental";

export default {
  props: [
    "theKeys",
    "activeTab",
    "isTheKeysSelected",
    "isSuperCheckinSelected",
    "isIgloohomeSelected",
    "igloohomeLocks",
    "netatmoDevices",
    "setNotatmoOrKey",
    "rental",
    "selectNetatmoDeviceId",
    "netatmoModules",
    "lock_type",
    "accountLockTypes",
    "superCheckinAccount",
    "superCheckinLocks",
    "lock_types",
    "onLockDetailsChange",
    "updateAllLocks",
    "getLocksOfAccount",
    "onLockConnect",
    "onChangeLockType",
    "stopWriting",
    "priceLabEnabled",
    "priceLabEmail",
    "priceLabApiKey",
    "nukiLocks",
    "isNukiLockSelected",
  ],
  components: {
    VueTimepicker: TimePicker,
  },
  data() {
    return {
      lockComputed: this.lock_type,
    };
  },
  computed: {
    disableInput() {
      return !this.priceLabEnabled;
    },
  },

  methods: {
    syncPriceLab() {
      rentalService.syncPriceLab(this, this.rental.id);
    },
    showPriceLab() {
      return (
        this.rental &&
        (this.rental.price_lab_enabled ||
          (!this.rental.price_lab_enabled &&
            !this.rental.dynamic_price_enabled))
      );
    },
  },
  watch: {
    lock_type(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.lockComputed = this.lock_type;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// services.vue?dbf97ba4